import React from 'react';
import { NeueToggleComponent } from '../components/toggle/component';

const LogoPlaceholder = () => (
  <div className='flex items-center justify-center gap-2 cursor-pointer'>
    <svg className='w-4 h-4 text-neue-journey-fg-50' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.04995 2.99922C9.04995 2.69546 8.80371 2.44922 8.49995 2.44922C8.19619 2.44922 7.94995 2.69546 7.94995 2.99922V7.44922H3.49995C3.19619 7.44922 2.94995 7.69546 2.94995 7.99922C2.94995 8.30298 3.19619 8.54922 3.49995 8.54922H7.94995V12.9992C7.94995 13.303 8.19619 13.5492 8.49995 13.5492C8.80371 13.5492 9.04995 13.303 9.04995 12.9992V8.54922H13.5C13.8037 8.54922 14.05 8.30298 14.05 7.99922C14.05 7.69546 13.8037 7.44922 13.5 7.44922H9.04995V2.99922Z'
        fill='currentColor'
      />
    </svg>
    <span className='text-neue-journey-small text-neue-journey-fg-50'>Click to add</span>
  </div>
);

export const LogoFrame = ({
  title,
  src,
  enabled,
  onToggle,
  onLogoClick,
  logoCount = 0,
}: {
  title: string;
  src?: string;
  enabled: boolean;
  onToggle: (value: boolean) => void;
  onLogoClick: () => void;
  logoCount: number;
}) => {
  return (
    <div className='flex flex-col gap-2'>
      <NeueToggleComponent
        wrapperClassName='py-0'
        label={title}
        checked={enabled && !!src}
        onChange={(value) => {
          if (src) {
            onToggle(value);
          }
        }}
        labelType='strong'
      />
      <div className='relative rounded-lg bg-neue-journey-fg-10 cursor-pointer py-4 h-12' onClick={onLogoClick}>
        {src ? <img src={src} alt='' className='h-5 m-auto' /> : <LogoPlaceholder />}
        {logoCount > 1 && (
          <div className='absolute right-2 top-2 h-5 w-5 rounded bg-neue-journey-fg-10'>
            <p className='flex items-center justify-center h-full text-neue-journey-small text-neue-journey-fg'>
              {logoCount}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
